/* global jQuery */
import isAdmin from '../../../helpers/isAdmin';

( ( $ ) => {
	const initializeBlock = ( $block ) => {
		if ( ! $block.length || isAdmin ) {
			return;
		}
        

        const slides = $( '.video-carousel' ).find( ".video-carousel-slider" ).data( 'value' );

		$block.slick( {
            
			dots: false,
			arrows: true,
            //prevArrow: '<span class="prev slick-prev"></span>',
			//nextArrow: '<span class="next slick-next"></span>',
			slidesToShow: slides,
            slidesToScroll: 1,
            initialSlide:1,
            infinite: true,
            focusOnSelect: true,
			accessibility: false,
            adaptiveHeight: true,
            centerMode: true,
            centerPadding: "0px",
			speed: 500,
            responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
                        centerPadding: "0px",
					},
				},
			],

		} );

		/*$('.video-carousel-slider').on('click', '.slick-slide a', function (e) {
			//e.stopPropagation();
			console.log("ini");
			var index = $(this).parent().closest('.slick-slide').data("slick-index");
			console.log(index);
			if ($('.video-carousel-slider').slick('slickCurrentSlide') !== index) {
				$('.video-carousel-slider').slick('slickGoTo', index);
			  }
			
		  });*/

		accessibilityFeatures();




		$( '.video-carousel-slider' ).on("afterChange", function (){
            accessibilityFeatures();
        });


		const ua = navigator.userAgent.toLowerCase();

		if ( ua.indexOf( 'safari' ) !== -1 ) {
			if ( ua.indexOf( 'chrome' ) > -1 ) {
				return;
			}

		}
        

	};

	const accessibilityFeatures = () => {

        $( '.video-carousel-slider .slick-slide' ).each(function(){
			
			$(this).attr('role', 'group');
			$(this).attr('aria-roledescription', 'slide');

            /*if ($(this).attr('aria-hidden') == 'true') {
                $(this).attr( 'tabindex', -1 );
				$(this).find("a").attr( 'tabindex', -1 );
              }
            else {
                $(this).attr( 'tabindex', 0 );
				$(this).find("a").attr( 'tabindex', -1 );
            }*/

			if (!$(this).hasClass('slick-current') ) {
                $(this).attr( 'tabindex', -1 );
				$(this).find("a").attr( 'tabindex', -1 );
              }
            else {
                $(this).attr( 'tabindex', -1 );
				$(this).find("a").attr( 'tabindex', 0 );
            }


        });
      };

	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		$( '.video-carousel-slider' ).not( '.slick-initialized' ).each( ( _index, element ) => {
			initializeBlock( $( element ) );
		} );
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=video-carousel',
			initializeBlock
		);
	}
} )( jQuery );
